import { render, staticRenderFns } from "./inventory-restock.vue?vue&type=template&id=1d66aefc"
import script from "./inventory-restock.vue?vue&type=script&lang=js"
export * from "./inventory-restock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports